"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.templateMapper = templateMapper;
const initialDataMapper_1 = require("./initialDataMapper");
const serviceSchemaMapper_1 = require("./serviceSchemaMapper");
const uiSchemaMapper_1 = require("./uiSchemaMapper");
function templateMapper(template, additionalData) {
    const { fillingBy, organizationUser, chatInfo } = additionalData;
    const services = organizationUser === null || organizationUser === void 0 ? void 0 : organizationUser.getDepartments();
    if (services && chatInfo) {
        const serviceFrequencies = ["HHA"];
        if (fillingBy)
            serviceFrequencies.push(fillingBy);
        (0, initialDataMapper_1.initialDataMapper)(template, services, chatInfo);
        (0, serviceSchemaMapper_1.servicesSchemaMapper)(template, services, serviceFrequencies);
        (0, uiSchemaMapper_1.servicesUISchemaMapper)(template, services, serviceFrequencies);
    }
    return template;
}
